module.exports = __webpack_public_path__ + "static/media/pintuan.f91a05ca.svg";